<template>
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{chevron: true, [direction]: true}">
        <path
            d="M1.5332 1.88892L8.32726 8.66501C8.37141 8.70899 8.40644 8.76121 8.43034 8.81869C8.45424 8.87618 8.46654 8.9378 8.46654 9.00003C8.46654 9.06226 8.45424 9.12388 8.43034 9.18136C8.40644 9.23885 8.37141 9.29107 8.32726 9.33504L1.5332 16.1111"
            stroke="#737370"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script lang="ts" setup>
    defineProps({direction: {type: String, required: false, default: 'right'}});
</script>
<style lang="scss">
    .chevron {
        &.left {
            transform: rotateZ(180deg);
        }
    }
</style>
